import React from "react";
import {Route, Switch} from "react-router-dom";

import asyncComponent from "../util/asyncComponent";

// Created once at module level. An asyncComponent created inside render is a new component on every
// render, so the page would remount (losing its state) whenever the URL changes, e.g. ?incident=.
const IncidentLog = asyncComponent(() => import('./IncidentLog'));
const NewIncident = asyncComponent(() => import('./IncidentLog/NewIncident'));

const App = ({match}) => (
    <div className="">
        <Switch>
            <Route path={`${match.url}/`} component={asyncComponent(() => import('./Home'))}/>
            <Route path={`${match.url}home`} component={asyncComponent(() => import('./Home'))}/>
            <Route path={`${match.url}pol-votes`} component={asyncComponent(() => import('./Home/PolVote'))}/>
            <Route path={`${match.url}retreat-partner-selection`} component={asyncComponent(() => import('./Home/RetreatSelection'))}/>
            <Route path={`${match.url}my-profile`} component={asyncComponent(() => import('./SelfService'))}/>
            <Route path={`${match.url}leave-tracker`} component={asyncComponent(() => import('./LeaveTracker'))}/>
            <Route path={`${match.url}paystubs`} component={asyncComponent(() => import('./Paystubs'))}/>
            <Route path={`${match.url}attendance`} component={asyncComponent(() => import('./Attendance'))}/>
            <Route path={`${match.url}documents`} component={asyncComponent(() => import('./Documents'))}/>
            <Route path={`${match.url}query`} component={asyncComponent(() => import('./EmployeeQueries'))}/>
            <Route path={`${match.url}training`} component={asyncComponent(() => import('./Training'))}/>
            <Route path={`${match.url}announcements`} component={asyncComponent(() => import('./Announcements'))}/>
            <Route path={`${match.url}exits`} component={asyncComponent(() => import('./EmployeeExits'))}/>
            <Route path={`${match.url}events`} component={asyncComponent(() => import('./Events'))}/>

            <Route path={`${match.url}appraisals/details/:slug`}
                   component={asyncComponent(() => import('./Appraisals/AppraisalDetails'))}/>
              <Route path={`${match.url}appraisals/:slug/:user_id`}
                   component={asyncComponent(() => import('./Appraisals/AppraisalDetails/AppraisalSubmissions'))}/>
            <Route path={`${match.url}appraisals`} component={asyncComponent(() => import('./Appraisals'))}/>
            <Route path={`${match.url}account-settings`} component={asyncComponent(() => import('./AccountSettings'))}/>
            <Route path={`${match.url}feedback/:slug`} component={asyncComponent(() => import('./Events/EventFeedback'))}/>
            <Route path={`${match.url}performance/goals/:slug`} component={asyncComponent(() => import('./PerformanceManagement/ViewGoal'))}/>
            <Route path={`${match.url}performance/okrs/:slug`} component={asyncComponent(() => import('./PerformanceManagement/ViewObjective'))}/>
            <Route path={`${match.url}performance/appraisals/:slug`} component={asyncComponent(() => import('./PerformanceManagement/ViewAppraisal'))}/>
            <Route path={`${match.url}performance/appraisals/:slug/single/:reviewId`} component={asyncComponent(() => import('./PerformanceManagement/ViewAppraisal/SingleAppraisal'))}/>
            <Route path={`${match.url}performance/competencies/:id`} component={asyncComponent(() => import('./PerformanceManagement/ViewCompetency'))}/>
            <Route path={`${match.url}performance`} component={asyncComponent(() => import('./PerformanceManagement'))}/>

            <Route path={`${match.url}incident-log/new`} component={NewIncident}/>
            <Route path={`${match.url}incident-log`} component={IncidentLog} />
        </Switch>
    </div>
);

export default App;
